<template>
<div class="main">
	<img src="https://oss.chinagreentown.com/guodi/jj7wxbQDMZPX.jpg" alt="" style="width:100%;height:auto">
     <div class="container">
         <router-view :key="key" />
     </div>
</div>
</template>
<script>
	export default {
		name: 'index',
		data () {
			return {
				key() {
					return this.$route.path
				},
				navPath:[]
			}
		},
		mounted:function (params) {
			this.getRouterBran()
		},
		methods:{
			getRouterBran () {
		//$route.matched属性 包含当前路由的所有 嵌套路径片段 的路由记录
		// 当 URL 为 /foo/bar，$route.matched 将会是一个包含从上到下的所有嵌套路由对象 (副本)，比如上面路由为二级路由，
		
		// 那么$route.matched的值为[{foo路由对象}，{bar路由对象}]
		//当url地址为/foo
		// 那么$route.matched的值为[{foo路由对象}]
		
		//当url地址为/home
		// 那么$route.matched的值为[{home路由对象}]
		let matche = this.$route.matched
		console.log(this.$route.matched)
		//所以 我这里以 /foo/bar为列
		// 得到嵌套的路由对象记录，筛选排除一些路由，条件自定
		// 我这里是筛选排除不带name 的路由，自己决定
		matche = matche.filter(item => item.name)
		this.navPath = matche
	}
		}
	}
</script>

<style lang="css" scoped>
/* .container{width: 100%;max-width: 960px;margin:auto} */
</style>


// WEBPACK FOOTER //
// src/layout/index.vue